var React = require('react');

function Trashcan (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M18.3 23H5.7C4.7064 23 3.9 22.1787 3.9 21.1667V6.5H20.1V21.1667C20.1 22.1787 19.2936 23 18.3 23ZM10.2 10.1667C10.2 9.66067 9.7968 9.25 9.3 9.25C8.8032 9.25 8.4 9.66067 8.4 10.1667V18.4167C8.4 18.9227 8.8032 19.3333 9.3 19.3333C9.7968 19.3333 10.2 18.9227 10.2 18.4167V10.1667ZM15.6 10.1667C15.6 9.66067 15.1968 9.25 14.7 9.25C14.2032 9.25 13.8 9.66067 13.8 10.1667V18.4167C13.8 18.9227 14.2032 19.3333 14.7 19.3333C15.1968 19.3333 15.6 18.9227 15.6 18.4167V10.1667ZM21 5.58333H3V3.75H8.4V2.375C8.4 1.61692 9.0057 1 9.75 1H14.25C14.9925 1 15.6 1.61508 15.6 2.375V3.75H21V5.58333ZM10.2 3.75H13.8V2.83333H10.2V3.75Z","fill":"currentColor"}));
}

Trashcan.defaultProps = {"viewBox":"0 0 24 24","fill":"currentColor"};

module.exports = Trashcan;

Trashcan.default = Trashcan;
